import { useState } from "react";
import dayjs from "dayjs";

import { getLoadId } from "@/utils/load";
import { LoadboardTime, MyOfferText, LoadboardCancelModal, LoadViewDetailsModal } from "@/components/dataPages/loadboard";
import { cn } from "@/utils/css";

export const MyOfferCard = ({ offer, index, onInteract }) => {
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const load = offer.loadBoardItem;
    const loadId = getLoadId(load.uniqueId);

    const handleClick = () => {
        if (onInteract) {
            onInteract();
        }
    };

    const hasCancel = offer.status === "PENDING" || (offer.status === "CONFIRMED" && offer.type === "quote");

    return (
        <>
            {index ? <div className="h-[1px] self-center w-[calc(100%-24px)] bg-cm-p-outline" /> : null}
            <div className={cn("flex flex-col p-3 hover:bg-cm-p-surface-hover gap-2 cursor-pointer")} onClick={handleClick}>
                <div className="flex flex-row items-start justify-between">
                    <div className="flex flex-row items-center h-[41px]">
                        <div>
                            <div className="w-[154px] font-medium text-cm-text-primary text-sm/[22px]">
                                {load.itineraryStops[0]?.stopCity
                                    ? `${load.itineraryStops[0]?.stopCity}, ${load.itineraryStops[0]?.stopState}`
                                    : "-"}
                            </div>
                            <div className="text-cm-p-text-secondary text-xs/[19px] flex flex-row gap-1">
                                <div>{dayjs(load.pickupDate).format("MMM DD")},</div>
                                <LoadboardTime stop={load.itineraryStops[0]} />
                            </div>
                        </div>
                        <div>
                            <div className="w-[154px] font-medium text-cm-text-primary text-sm/[22px]">
                                {load.itineraryStops[load.itineraryStops.length - 1]?.stopCity
                                    ? `${load.itineraryStops[load.itineraryStops.length - 1]?.stopCity}, ${load.itineraryStops[load.itineraryStops.length - 1]?.stopState}`
                                    : "-"}
                            </div>
                            <div className="text-cm-p-text-secondary text-xs/[19px] flex flex-row gap-1">
                                {dayjs(load.deliveryDate).format("MMM DD")},
                                <LoadboardTime stop={load.itineraryStops[load.itineraryStops.length - 1]} />
                            </div>
                        </div>
                    </div>
                    <div className="text-cm-p-text-primary font-medium text-sm/[22px]">{loadId}</div>
                </div>
                <div className="flex flex-row justify-between items-center">
                    <MyOfferText offer={offer} />
                    <div className="flex flex-row items-center gap-5">
                        {hasCancel ? (
                            <LoadboardCancelModal
                                offer={offer}
                                open={openCancelModal}
                                onOpenChange={setOpenCancelModal}
                                isDisabled={false}
                                reasonType="myOffers"
                            />
                        ) : null}
                        <LoadViewDetailsModal offer={offer} open={openDetailsModal} onOpenChange={setOpenDetailsModal} />
                    </div>
                </div>
            </div>
        </>
    );
};
